import { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Logo } from "../components/Logo";
import { PBox, PSection, PLink, PImg } from "../theme/BaseTheme";
import { Dropdown, Tag, Tabs } from "antd";
import Sticky from "react-sticky-el";
import { userSignOut, refetchUser } from "../../actions/auth";

const imageGenerators = [
    {
        label: <a href={`/seamless-pattern`}>Seamless Pattern Generator</a>,
        key: "seamless-pattern-generator",
        video: "/images/landing/pattern-preview.mp4",
    },
    {
        label: <a href={`/product-image-generator`}>Product Image Generator</a>,
        key: "product-image-generator",
        video: "/images/landing/product-image-preview.mp4",
    },
    {
        label: <a href={`/mockup`}>Mockup Generator</a>,
        key: "mockup-generator",
        video: "/images/landing/mockup-preview.mp4",
    },
    {
        label: <a href={`/tee-design`}>Tee Design Generator</a>,
        key: "tee-design-generator",
        video: "/images/landing/tee-preview.mp4",
    },
    {
        label: <a href={`/interior-design`}>Interior Design Generator</a>,
        key: "interior-design-generator",
        video: "/images/landing/interior-design-preview.mp4",
    },
    {
        label: <a href={`/linkedin-headshot`}>LinkedIn Headshot Generator</a>,
        key: "linkedin-headshot-generator",
        video: "/images/landing/linkedin-headshot-preview.mp4",
    },
    {
        label: <a href={`/text-poster`}>Text Poster Generator</a>,
        key: "text-poster-generator",
        video: "/images/landing/text-poster-preview.mp4",
    },
];

const imageEditors = [
    {
        label: <a href={`/outline-maker`}>Outline Maker</a>,
        key: "outline-maker",
        video: "/images/landing/outline-maker-preview.mp4",
    },
    {
        label: <a href={`/background-remover`}>Background Remover</a>,
        key: "background-remover",
        video: "/images/landing/bg-remover-preview.mp4",
    },
    {
        label: <a href={`/binary-mask-generator`}>Binary Mask Generator</a>,
        key: "binary-mask-generator",
        video: "/images/landing/binary-mask-preview.mp4",
    },
    {
        label: <a href={`/image-upscaler`}>Image Upscaler</a>,
        key: "image-upscaler",
        video: "/images/landing/upscaler-preview.mp4",
    },
    {
        label: <a href={`/object-remover`}>Object Remover</a>,
        key: "object-remover",
        video: "/images/landing/object-remover-preview.mp4",
    },
];

const imageFilters = [
    {
        label: <a href={`/ai-comic-filter`}>AI Comic Filter</a>,
        key: "ai-comic-filter",
        image: "/images/image-filters/comic-filter-cover.webp",
    },
    {
        label: <a href={`/ai-ghibli-filter`}>AI Ghibli Filter</a>,
        key: "ai-ghibli-filter",
        image: "/images/image-filters/ghibli-filter-cover.webp",
    },
    {
        label: <a href={`/ai-manga-filter`}>AI Manga Filter</a>,
        key: "ai-manga-filter",
        image: "/images/image-filters/manga-filter-cover.webp",
    },
    {
        label: <a href={`/ai-oil-painting-filter`}>AI Oil Painting Filter</a>,
        key: "ai-oil-painting-filter",
        image: "/images/image-filters/oil-painting-filter-cover.webp",
    },
    {
        label: <a href={`/ai-pixel-art-filter`}>AI Pixel Art Filter</a>,
        key: "ai-pixel-art-filter",
        image: "/images/image-filters/pixel-art-filter-cover.webp",
    },
    {
        label: (
            <a href={`/ai-rick-and-morty-filter`}>AI Rick And Morty Filter</a>
        ),
        key: "ai-rick-and-morty-filter",
        image: "/images/image-filters/rick-and-morty-filter-cover.webp",
    },
    {
        label: <a href={`/ai-rococo-filter`}>AI Rococo Filter</a>,
        key: "ai-rococo-filter",
        image: "/images/image-filters/rococo-filter-cover.webp",
    },
    {
        label: <a href={`/ai-simpson-filter`}>AI Simpson Filter</a>,
        key: "ai-simpson-filter",
        image: "/images/image-filters/simpson-filter-cover.webp",
    },
];

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchKey: "",
            isLoading: true,
            activeToolsTab: "generators",
            hoveredTool: null,
        };
    }
    async componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const refetch = urlParams.get("refetch");
        if (refetch === "true") {
            await this.props.refetchUser();
        }
        this.setState({ isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <></>;
        }
        return (
            <PSection css={styles}>
                <Sticky>
                    <PBox className="header-wrapper">
                        <PBox className="header">
                            <Logo />
                            <PBox className="search-bar">
                                <Dropdown
                                    trigger={["click"]}
                                    placement="bottomLeft"
                                    getPopupContainer={(triggerNode) =>
                                        triggerNode.parentNode
                                    }
                                    dropdownRender={() => (
                                        <PBox className="tools-dropdown">
                                            <PBox className="tools-tabs">
                                                <PBox className="tab-buttons">
                                                    <PBox
                                                        className={`tab-button ${
                                                            this.state
                                                                .activeToolsTab ===
                                                            "generators"
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                        onClick={() =>
                                                            this.setState({
                                                                activeToolsTab:
                                                                    "generators",
                                                            })
                                                        }
                                                    >
                                                        Image Generators
                                                    </PBox>
                                                    <PBox
                                                        className={`tab-button ${
                                                            this.state
                                                                .activeToolsTab ===
                                                            "editors"
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                        onClick={() =>
                                                            this.setState({
                                                                activeToolsTab:
                                                                    "editors",
                                                            })
                                                        }
                                                    >
                                                        Image Editors
                                                    </PBox>
                                                    <PBox
                                                        className={`tab-button ${
                                                            this.state
                                                                .activeToolsTab ===
                                                            "filters"
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                        onClick={() =>
                                                            this.setState({
                                                                activeToolsTab:
                                                                    "filters",
                                                            })
                                                        }
                                                    >
                                                        Image Filters
                                                    </PBox>
                                                </PBox>
                                            </PBox>
                                            <PBox className="tools-content">
                                                <PBox className="tools-list">
                                                    {this.state
                                                        .activeToolsTab ===
                                                        "generators" &&
                                                        imageGenerators.map(
                                                            (item) => (
                                                                <PBox
                                                                    key={
                                                                        item.key
                                                                    }
                                                                    className="tool-item"
                                                                    onMouseEnter={() =>
                                                                        this.setState(
                                                                            {
                                                                                hoveredTool:
                                                                                    item,
                                                                            }
                                                                        )
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        this.setState(
                                                                            {
                                                                                hoveredTool:
                                                                                    null,
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    {item.label}
                                                                </PBox>
                                                            )
                                                        )}
                                                    {this.state
                                                        .activeToolsTab ===
                                                        "editors" &&
                                                        imageEditors.map(
                                                            (item) => (
                                                                <PBox
                                                                    key={
                                                                        item.key
                                                                    }
                                                                    className="tool-item"
                                                                    onMouseEnter={() =>
                                                                        this.setState(
                                                                            {
                                                                                hoveredTool:
                                                                                    item,
                                                                            }
                                                                        )
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        this.setState(
                                                                            {
                                                                                hoveredTool:
                                                                                    null,
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    {item.label}
                                                                </PBox>
                                                            )
                                                        )}
                                                    {this.state
                                                        .activeToolsTab ===
                                                        "filters" &&
                                                        imageFilters.map(
                                                            (item) => (
                                                                <PBox
                                                                    key={
                                                                        item.key
                                                                    }
                                                                    className="tool-item"
                                                                    onMouseEnter={() =>
                                                                        this.setState(
                                                                            {
                                                                                hoveredTool:
                                                                                    item,
                                                                            }
                                                                        )
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        this.setState(
                                                                            {
                                                                                hoveredTool:
                                                                                    null,
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    {item.label}
                                                                </PBox>
                                                            )
                                                        )}
                                                </PBox>
                                                <PBox className="tools-preview">
                                                    {this.state.hoveredTool
                                                        ?.video && (
                                                        <video
                                                            autoPlay
                                                            muted
                                                            loop
                                                        >
                                                            <source
                                                                src={
                                                                    this.state
                                                                        .hoveredTool
                                                                        .video
                                                                }
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    )}
                                                    {this.state.hoveredTool
                                                        ?.image && (
                                                        <PImg
                                                            src={
                                                                this.state
                                                                    .hoveredTool
                                                                    .image
                                                            }
                                                            alt={
                                                                this.state
                                                                    .hoveredTool
                                                                    .label
                                                            }
                                                        />
                                                    )}
                                                </PBox>
                                            </PBox>
                                        </PBox>
                                    )}
                                >
                                    <PLink className="sign-in">Tools</PLink>
                                </Dropdown>
                                <Dropdown
                                    trigger={["click"]}
                                    menu={{
                                        items: [
                                            {
                                                label: (
                                                    <a
                                                        href={`/pattern-gallery/1`}
                                                    >
                                                        Pattern Gallery
                                                    </a>
                                                ),
                                                key: "pattern-gallery",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/mockup-gallery/print`}
                                                    >
                                                        Mockup Gallery
                                                    </a>
                                                ),
                                                key: "mockup-gallery",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/tee-design-gallery/1`}
                                                    >
                                                        Tee Design Gallery
                                                    </a>
                                                ),
                                                key: "tee-design-gallery",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/poster-gallery/1`}
                                                    >
                                                        Text Poster Gallery
                                                    </a>
                                                ),
                                                key: "poster-gallery",
                                            },
                                        ],
                                    }}
                                >
                                    <PLink className="sign-in">Gallery</PLink>
                                </Dropdown>

                                <PLink className="sign-in" href="/pricing">
                                    Pricing
                                </PLink>
                            </PBox>
                            {!this.props.userAuth?.isLoggedIn && (
                                <PLink className="sign-in" href="/sign-in">
                                    Sign in
                                </PLink>
                            )}
                            {this.props.userAuth?.isLoggedIn && (
                                <PBox className="credits">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1.75rem"
                                        height="1.75rem"
                                        fill="#000000"
                                        viewBox="0 0 256 256"
                                    >
                                        <path d="M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48Zm16,144a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V80A16,16,0,0,1,56,64H200a16,16,0,0,1,16,16Zm-52-56H92a28,28,0,0,0,0,56h72a28,28,0,0,0,0-56Zm-28,16v24H120V152ZM80,164a12,12,0,0,1,12-12h12v24H92A12,12,0,0,1,80,164Zm84,12H152V152h12a12,12,0,0,1,0,24ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm88,0a12,12,0,1,1,12,12A12,12,0,0,1,160,108Z"></path>
                                    </svg>
                                    {this.props.userAuth?.userAccount?.credits +
                                        this.props.userAuth?.userAccount
                                            ?.roll_over_credits}
                                </PBox>
                            )}
                            {this.props.userAuth?.isLoggedIn && (
                                <PBox className="account">
                                    <Dropdown
                                        menu={{
                                            items: [
                                                {
                                                    label: (
                                                        <PBox className="account-user-details">
                                                            <PBox>
                                                                <b>
                                                                    {
                                                                        this
                                                                            .props
                                                                            .userAuth
                                                                            ?.userAccount
                                                                            ?.user_name
                                                                    }
                                                                </b>{" "}
                                                                {this.props
                                                                    .userAuth
                                                                    ?.userAccount
                                                                    ?.plan ===
                                                                    "free" && (
                                                                    <Tag>
                                                                        Free
                                                                    </Tag>
                                                                )}
                                                                {this.props.userAuth?.userAccount?.plan.includes(
                                                                    "starter"
                                                                ) && (
                                                                    <Tag color="purple">
                                                                        Starter
                                                                    </Tag>
                                                                )}
                                                                {this.props.userAuth?.userAccount?.plan.includes(
                                                                    "standard"
                                                                ) && (
                                                                    <Tag color="blue">
                                                                        Standard
                                                                    </Tag>
                                                                )}
                                                                {this.props.userAuth?.userAccount?.plan.includes(
                                                                    "pro"
                                                                ) && (
                                                                    <Tag color="gold">
                                                                        Pro
                                                                    </Tag>
                                                                )}
                                                            </PBox>
                                                            <PBox>
                                                                {
                                                                    this.props
                                                                        .userAuth
                                                                        ?.userAccount
                                                                        ?.email
                                                                }
                                                            </PBox>
                                                        </PBox>
                                                    ),
                                                    key: "credits",
                                                },
                                                { type: "divider" },
                                                {
                                                    label: (
                                                        <a href={`/patterns/1`}>
                                                            My Patterns
                                                        </a>
                                                    ),
                                                    key: "patterns",
                                                },
                                                {
                                                    label: (
                                                        <a
                                                            href={`/product-images/1`}
                                                        >
                                                            My Product Images
                                                        </a>
                                                    ),
                                                    key: "product-images",
                                                },
                                                {
                                                    label: (
                                                        <a href={`/tees/1`}>
                                                            My Tee Designs
                                                        </a>
                                                    ),
                                                    key: "tee-designs",
                                                },
                                                {
                                                    label: (
                                                        <a
                                                            href={`/interior-designs/1`}
                                                        >
                                                            My Interior Designs
                                                        </a>
                                                    ),
                                                    key: "interior-designs",
                                                },
                                                {
                                                    label: (
                                                        <a
                                                            href={`/linkedin-headshots/1`}
                                                        >
                                                            My LinkedIn
                                                            Headshots
                                                        </a>
                                                    ),
                                                    key: "linkedin-headshots",
                                                },
                                                {
                                                    label: (
                                                        <a href={`/outlines/1`}>
                                                            My Outlined Images
                                                        </a>
                                                    ),
                                                    key: "outlines",
                                                },
                                                {
                                                    label: (
                                                        <a
                                                            href={`/filtered-images/1`}
                                                        >
                                                            My Filtered Images
                                                        </a>
                                                    ),
                                                    key: "filtered-images",
                                                },
                                                {
                                                    label: (
                                                        <a href={`/posters/1`}>
                                                            My Posters
                                                        </a>
                                                    ),
                                                    key: "posters",
                                                },
                                                { type: "divider" },
                                                {
                                                    label: (
                                                        <a
                                                            href={`/manage-subscription`}
                                                        >
                                                            Manage Subscription
                                                        </a>
                                                    ),
                                                    key: "subscription",
                                                },
                                                {
                                                    label: (
                                                        <PBox
                                                            onClick={() => {
                                                                this.props
                                                                    .userSignOut()
                                                                    .then(
                                                                        () => {
                                                                            this.props.history.push(
                                                                                "/sign-out"
                                                                            );
                                                                        }
                                                                    );
                                                            }}
                                                        >
                                                            Sign Out
                                                        </PBox>
                                                    ),
                                                    key: "signout",
                                                },
                                            ],
                                        }}
                                        trigger={["click"]}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1.75rem"
                                            height="1.75rem"
                                            viewBox="0 0 256 256"
                                        >
                                            <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"></path>
                                        </svg>
                                    </Dropdown>
                                </PBox>
                            )}

                            {this.props.userAuth?.isLoggedIn && (
                                <Dropdown
                                    trigger={["click"]}
                                    menu={{
                                        items: [
                                            {
                                                label: (
                                                    <a
                                                        href={`/seamless-pattern/app`}
                                                    >
                                                        Generating Pattern
                                                    </a>
                                                ),
                                                key: "seamless-pattern-generator",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/product-image-generator/app`}
                                                    >
                                                        Generating Product Image
                                                    </a>
                                                ),
                                                key: "product-image-generator",
                                            },
                                            {
                                                label: (
                                                    <a href={`/mockup/app`}>
                                                        Generating Mockup
                                                    </a>
                                                ),
                                                key: "mockup-generator",
                                            },
                                            {
                                                label: (
                                                    <a href={`/tee-design/app`}>
                                                        Generating Tee Design
                                                    </a>
                                                ),
                                                key: "tee-design-generator",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/interior-design/app`}
                                                    >
                                                        Generating Interior
                                                        Design
                                                    </a>
                                                ),
                                                key: "interior-design-generator",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/linkedin-headshot/app`}
                                                    >
                                                        Generating LinkedIn
                                                        Headshot
                                                    </a>
                                                ),
                                                key: "linkedin-headshot-generator",
                                            },
                                            {
                                                label: (
                                                    <a href={`/text-poster`}>
                                                        Generating Text Poster
                                                    </a>
                                                ),
                                                key: "text-poster-generator",
                                            },
                                            {
                                                type: "divider",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/outline-maker/app`}
                                                    >
                                                        Making Outline
                                                    </a>
                                                ),
                                                key: "outline-maker",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/background-remover/app`}
                                                    >
                                                        Removing Background
                                                    </a>
                                                ),
                                                key: "background-remover",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/binary-mask-generator/app`}
                                                    >
                                                        Generating Binary Mask
                                                    </a>
                                                ),
                                                key: "binary-mask-generator",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/image-upscaler/app`}
                                                    >
                                                        Upscaling Image
                                                    </a>
                                                ),
                                                key: "image-upscaler",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/object-remover/app`}
                                                    >
                                                        Removing Objects
                                                    </a>
                                                ),
                                                key: "object-remover",
                                            },
                                            {
                                                type: "divider",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-comic-filter`}
                                                    >
                                                        Applying Comic Filter
                                                    </a>
                                                ),
                                                key: "comic-filter",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-ghibli-filter`}
                                                    >
                                                        Applying Ghibli Filter
                                                    </a>
                                                ),
                                                key: "ghibli-filter",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-manga-filter`}
                                                    >
                                                        Applying Manga Filter
                                                    </a>
                                                ),
                                                key: "manga-filter",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-oil-painting-filter`}
                                                    >
                                                        Applying Oil Painting
                                                        Filter
                                                    </a>
                                                ),
                                                key: "oil-painting-filter",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-pixel-art-filter`}
                                                    >
                                                        Applying Pixel Art
                                                        Filter
                                                    </a>
                                                ),
                                                key: "pixel-art-filter",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-rick-and-morty-filter`}
                                                    >
                                                        Applying Rick And Morty
                                                        Filter
                                                    </a>
                                                ),
                                                key: "rick-and-morty-filter",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-rococo-filter`}
                                                    >
                                                        Applying Rococo Filter
                                                    </a>
                                                ),
                                                key: "rococo-filter",
                                            },
                                            {
                                                label: (
                                                    <a
                                                        href={`/ai-simpson-filter`}
                                                    >
                                                        Applying Simpson Filter
                                                    </a>
                                                ),
                                                key: "simpson-filter",
                                            },
                                        ],
                                    }}
                                >
                                    <PLink
                                        className="banner-browsing-button"
                                        //href="/seamless-pattern/app"
                                    >
                                        Start
                                    </PLink>
                                </Dropdown>
                            )}

                            {!this.props.userAuth?.isLoggedIn && (
                                <PLink
                                    className="banner-browsing-button"
                                    href="/sign-up"
                                >
                                    Sign up
                                </PLink>
                            )}
                        </PBox>
                    </PBox>
                </Sticky>
            </PSection>
        );
    }
}

const styles = {
    zIndex: "100",
    "& .tools-dropdown": {
        backgroundColor: "#fff !important",
        borderRadius: "8px !important",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15) !important",
        display: "flex !important",
        width: "800px !important",
        padding: "0 !important",
        maxHeight: "320px !important",
    },
    "& .tools-tabs": {
        width: "200px !important",
        borderRight: "1px solid #e8e8e8 !important",
        backgroundColor: "#fff !important",
        borderTopLeftRadius: "8px !important",
        borderBottomLeftRadius: "8px !important",
    },
    "& .tab-buttons": {
        display: "flex !important",
        flexDirection: "column !important",
        width: "100% !important",
    },
    "& .tab-button": {
        padding: "12px 16px !important",
        cursor: "pointer !important",
        fontSize: "14px !important",
        fontWeight: "500 !important",
        color: "#666 !important",
        transition: "all 0.3s !important",
        borderRight: "3px solid transparent !important",
        "&:hover": {
            color: "#6d28d9 !important",
            fontWeight: "600",
        },
        "&.active": {
            color: "#6d28d9 !important",
            fontWeight: "600 !important",
            borderRightColor: "#6d28d9 !important",
        },
    },
    "& .tools-content": {
        flex: "1 !important",
        display: "flex !important",
        height: "320px !important",
    },
    "& .tools-list": {
        width: "300px !important",
        padding: "16px !important",
        display: "flex !important",
        flexDirection: "column !important",
        gap: "8px !important",
        borderRight: "1px solid #e8e8e8 !important",
        overflowY: "scroll !important",
        "&::-webkit-scrollbar": {
            width: "8px !important",
        },
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1 !important",
            borderRadius: "4px !important",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#ccc !important",
            borderRadius: "4px !important",
            "&:hover": {
                background: "#bbb !important",
            },
        },
    },
    "& .tools-preview": {
        flex: "1 !important",
        display: "flex !important",
        alignItems: "center !important",
        justifyContent: "center !important",
        padding: "16px !important",
        backgroundColor: "#fafafa !important",
        "& video": {
            width: "100% !important",
            maxWidth: "280px !important",
            maxHeight: "280px !important",
            objectFit: "contain !important",
            borderRadius: "8px !important",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1) !important",
        },
        "& img": {
            width: "100% !important",
            maxWidth: "280px !important",
            maxHeight: "280px !important",
            objectFit: "contain !important",
            borderRadius: "8px !important",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1) !important",
        },
    },
    "& .tool-item": {
        padding: "10px 12px !important",
        borderRadius: "6px !important",
        transition: "all 0.3s !important",
        "&:hover": {
            backgroundColor: "rgb(238, 236, 255) !important",
            "& a": {
                color: "#6d28d9 !important",
            },
        },
        "& a": {
            color: "#333 !important",
            textDecoration: "none !important",
            display: "block !important",
            width: "100% !important",
        },
    },
    "& .header-wrapper": {
        borderBottom: "1px solid $colors$borderColor",
        backgroundColor: "#fff",

        padding: "0.75rem 1rem",
    },
    "& .header": {
        paddingTop: "2px",
        paddingBottom: "2px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        maxWidth: "80rem",
        margin: "0 auto",
    },
    "& .search-bar": {
        display: "flex",
        flexGrow: "1",
        marginLeft: "1rem",
        marginRight: "1rem",
    },
    "& .sign-in": {
        marginRight: "1rem",
        textDecoration: "none",
        fontWeight: "600",
        fontSize: "14px",
        color: "$colors$text",
        cursor: "pointer",
        "&:hover": {
            color: "$colors$primary",
        },
    },
    "& .start-selling": {
        marginRight: "10px",
        paddingRight: "10px",
        textDecoration: "none",
        fontWeight: "600",
        fontSize: "14px",
        borderRight: "1px solid $colors$label",
    },
    "& .shopping-cart": {
        cursor: "pointer",
        margin: "0 6px",
        display: "block",
        "& span": { display: "block" },
        "& svg": { fill: "$colors$text", display: "block" },
        "& svg:hover": { fill: "$colors$link" },
    },
    "& .shop-dashboard": {
        cursor: "pointer",
        margin: "0 6px",
        "& svg": { fill: "$colors$text" },
        "& svg:hover": { fill: "$colors$link" },
    },
    "& .account": {
        cursor: "pointer",
        margin: "0 1rem 0 0",
        "& svg": { fill: "$colors$text", display: "block" },
        "& svg:hover": { fill: "$colors$link" },
    },
    "& .credits": {
        cursor: "pointer",
        margin: "0 1rem",
        display: "flex",
        alignItems: "center",
        fontWeight: "700",
        "& svg": {
            fill: "$colors$text",
            display: "block",
            marginRight: "0.75rem",
        },
        "& svg:hover": { fill: "$colors$link" },
        "&:hover": { color: "$colors$primary" },
    },
    "& .banner-browsing-button": {
        fontWeight: "600",
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
        color: "#fff",
        padding: "0.625rem 0.875rem",
        backgroundColor: "$colors$primary",
        borderRadius: "0.375rem",
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "$colors$primary500",
        },
    },
    "& .account-user-details": {
        padding: "0.5rem 0",
    },
};

function mapStateToProps(state) {
    return {
        userAuth: state.authReducer?.userAuth,
    };
}

export default connect(mapStateToProps, { userSignOut, refetchUser })(
    withRouter(Header)
);
